import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const Markdown = ({ text, testid }) => (
  <div className="toth-md text-sm leading-relaxed" data-testid={testid}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{text || ""}</ReactMarkdown>
  </div>
);
